export function briefTestId(...parts: Array<string | number | null | undefined>) {
    return parts
        .filter((part): part is string | number => part !== null && part !== undefined)
        .map((part) =>
            String(part)
                .trim()
                .replace(/([a-z0-9])([A-Z])/g, '$1-$2')
                .replace(/[^a-zA-Z0-9]+/g, '-')
                .replace(/^-+|-+$/g, '')
                .toLowerCase()
        )
        .filter(Boolean)
        .join('-');
}
